import { FaSearch } from "react-icons/fa";
import "./ProviderSearchBar.css";

export default function ProviderSearchBar({
  search,
  setSearch,
}) {
  return (
    <div className="provider-search-container">

      <div className="provider-search-box">

        <FaSearch className="provider-search-icon" />

        <input
          type="text"
          placeholder="Search dishes, meals, drinks..."
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
        />

      </div>

    </div>
  );
}